var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "right-btn-wrap" }, [
    _vm.checkPermission(["ROLE_ADMIN", "ROLE_CYY_USER", "ROLE_GOVERNMENT"])
      ? _c("span", { on: { click: _vm.videoClick } }, [_vm._v("实时农情")])
      : _vm._e(),
    _c("span", { on: { click: _vm.qjlick } }, [_vm._v("360全景")]),
    _c("span", { on: { click: _vm.scienceClick } }, [_vm._v("科普导览")]),
    _c("span", { on: { click: _vm.newClick } }, [_vm._v("大事记")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }